if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
    var params = {
        type: 'POST',
        url: '/cart/add.js',
        data: jQuery(form).serialize(),
        dataType: 'json',
        success: function(line_item) {
            if ((typeof callback) === 'function') {
                callback(line_item, form);
            }
            else {
                ShopifyAPI.onItemAdded(line_item, form);
            }
        },
        error: function(XMLHttpRequest, textStatus) {
            if ((typeof errorCallback) === 'function') {
                errorCallback(XMLHttpRequest, textStatus);
            }
        }
    };
    jQuery.ajax(params);
};

ShopifyAPI.getCart = function(callback) {
    jQuery.getJSON('/cart.js', function (cart, textStatus) {
        if ((typeof callback) === 'function') {
            callback(cart);
        }
        else {
            ShopifyAPI.onCartUpdate(cart);
        }
    });
};

ShopifyAPI.changeItem = function(line, quantity, callback) {
    var params = {
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + quantity + '&line=' + line,
        dataType: 'json',
        success: function(cart) {
            if ((typeof callback) === 'function') {
                callback(cart);
            }
            else {
                ShopifyAPI.onCartUpdate(cart);
            }
        },
        error: function(XMLHttpRequest, textStatus, cart) {
            console.log('error')
        }
    };
    jQuery.ajax(params);
};

var init, loadCart;

// Private plugin variables
var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer, $body, $buildCart;

// Private functions
var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, adjustCartCallback, cartUpdateCallback, cartUpdateCallbackInitial, validateQty;

init = function() {
    // Default settings
    settings = {
        addToCartSelector  : 'input[type="submit"]',
        cartCountSelector  : '.drawer__item-count',
        cartContainer      : '#cart__drawer_items'
    };

    $formContainer     = $('form.shopify-product-form');
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartContainer     = $(settings.cartContainer);

    $body = $('body');
};
formOverride = function () {
    $formContainer.on('submit', function(evt) {
        evt.preventDefault();

        // Add class to be styled if desired
        $addToCart.removeClass('is-added').addClass('is-adding');

        // Remove any previous quantity errors
        $('.qty-error').remove();

        ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback.bind(this));
    });
};

itemAddedCallback = function (product) {
    $addToCart.removeClass('is-adding').addClass('is-added');
    ShopifyAPI.getCart(cartUpdateCallback);
};

itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var $form = $(this);
    var $button = $form.find(settings.addToCartSelector);
    var data = eval('(' + XMLHttpRequest.responseText + ')');

    $button.removeClass('is-adding is-added');

    if (!!data.message) {
        if (data.status == 422) {
            $form.after('<div class="errors qty-error">'+ data.description +'</div>')
        }
    }
};

cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);
    cartCallback(cart);
};

cartUpdateCallbackInitial = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);
};
updateCountPrice = function (cart) {
    if ($cartCountSelector) {
        $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

        if (cart.item_count === 0) {
            $cartCountSelector.addClass('hidden-count');
        }
    }
    if ($cartCostSelector) {
        $cartCostSelector.html(Shopify.formatMoney(cart.total_price, Shopify.money_format));
    }
};

function setCookie(name, value) {
    let now = new Date();
    let time = now.getTime();
    let expireTime = time + 365 * 86400000;
    now.setTime(expireTime);
    document.cookie = name + '=' + value + ';expires='+now.toUTCString()+';path=/';
}
function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}
buildCart = function (cart) {
    let line_item = '';
    $cartContainer.empty();
    //cart gifts
    cartId = [];
    cart.items.forEach(function (item) {
        cartId.push((item.id).toString());
    })
    if(cart.items.length > 0) {
        cart.items.forEach(function(product, index) {
            let productTitle = product.product_title.split(" ").splice(0, 12).join(" ");
            line_item +=
                `
            <div class="line-item" data-line="${index+1}" data-id="${product.id}">
               <div class="line-item__boday">
                <div class="line-item__image">
                  <img src="${product.featured_image.url}" alt="${product.featured_image.alt}">
                </div>
              </div>
              <div class="line-item__header">
                <div class="line-item__title">
                  <p>${productTitle}</p>
                </div>
                <div class="line-item__options">
                  <p>${(!product.variant_options[1]) ? product.variant_options[0] : product.variant_options[0] + ', ' + product.variant_options[1]}</p>
                </div>
                <div class="line-item__box">
                    <div class="line-item__qty">
                      <div class="qtybox">
                        <button type="button" data-line="${index+1}" class="btnqty qtyminus">-</button>
                        <input type="text" id="quantity" name="quantity" value="${product.quantity}" min="1" class="quantity-selector quantity-input" readonly="">
                        <button type="button" data-line="${index+1}" class="btnqty qtyplus">+</button>
                      </div>
                    </div>
                    <p class="line-item__original-price">${(product.original_line_price === product.final_line_price) ? '' : Shopify.formatMoney(product.original_line_price, Shopify.money_format)}</p>
                    <p class="line-item__price discounted-${product.final_line_price}">${Shopify.formatMoney(product.final_line_price, Shopify.money_format)}</p>
                </div>
                <button data-line="${index+1}" class="line-item__remove-btn">
                  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="20" viewBox="0 0 19 20" fill="none">
                    <path d="M2 19.8C1.9 19.7 1.8 19.5 1.8 19.4V4.4H0.6C0.4 4.4 0.3 4.3 0.1 4.2C2.23517e-08 4.1 0 3.9 0 3.8C0 3.6 0.0999999 3.5 0.2 3.4C0.3 3.2 0.4 3.1 0.6 3.1H5.6V0.6C5.6 0.4 5.7 0.3 5.8 0.2C5.9 0.1 6.1 0 6.2 0H12.5C12.7 0 12.8 0.1 12.9 0.2C13 0.3 13.1 0.5 13.1 0.6V3.1H18.1C18.3 3.1 18.4 3.2 18.5 3.3C18.6 3.4 18.7 3.6 18.7 3.7C18.7 3.9 18.6 4 18.5 4.1C18.4 4.2 18.2 4.3 18.1 4.3H16.8V19.3C16.8 19.5 16.7 19.6 16.6 19.7C16.5 19.8 16.3 19.9 16.2 19.9H2.5C2.3 20 2.1 19.9 2 19.8ZM15.6 4.4H3.1V18.8H15.6V4.4ZM6.7 7.7C6.8 7.8 6.9 8 6.9 8.1V15C6.9 15.2 6.8 15.3 6.7 15.4C6.6 15.5 6.4 15.6 6.3 15.6C6.2 15.6 6 15.5 5.9 15.4C5.8 15.3 5.7 15.1 5.7 15V8.1C5.7 7.9 5.8 7.8 5.9 7.7C6 7.6 6.2 7.5 6.3 7.5C6.4 7.5 6.5 7.6 6.7 7.7ZM6.8 3.1H11.8V1.3H6.8V3.1ZM9.8 7.7C9.9 7.8 10 8 10 8.1V15C10 15.2 9.9 15.3 9.8 15.4C9.7 15.5 9.5 15.6 9.4 15.6C9.3 15.6 9.1 15.5 9 15.4C8.9 15.3 8.8 15.1 8.8 15V8.1C8.8 7.9 8.9 7.8 9 7.7C9.1 7.6 9.3 7.5 9.4 7.5C9.5 7.5 9.7 7.6 9.8 7.7ZM12 7.7C12.1 7.6 12.3 7.5 12.4 7.5C12.5 7.5 12.7 7.6 12.8 7.7C12.9 7.8 13 8 13 8.1V15C13 15.2 12.9 15.3 12.8 15.4C12.7 15.5 12.5 15.6 12.4 15.6C12.3 15.6 12.1 15.5 12 15.4C11.9 15.3 11.8 15.1 11.8 15V8.1C11.8 8 11.9 7.8 12 7.7Z" fill="#013A81"/>
                  </svg>
                </button>
                <div data-line="${index+1}" class="line-item__fakeremove-btn" style="display:none;">
                </div>
              </div>
            </div>
            `;
            let productNum = product.id.toString();
            $('.cart-gift').show();
            setTimeout(function () {
                if(cartId.indexOf(productNum) != -1) {
                    let findedGift = $(`.cart-gift .product-wrapper[data-id="${product.id}"]`).closest('.cart-gift');
                    findedGift.hide();
                }
            }, 100)
        });
        $cartContainer.append(line_item);
    } else {
        document.getElementById('cart__drawer_items').innerHTML = '<p>Cart is empty</p>';
    }
    $('.updated-total').html(Shopify.formatMoney(cart.total_price, Shopify.money_format));
    $('.updated-total').attr('data-total', cart.total_price);


    console.log('update')

    let current = +$('.updated-total').text().replace('$', '');
    let amount = $('.amount-to-receive');
    let product_gift = $('.product-to-receive');

    let firstGift = getCookie(`${window.cartgift_product1_id}`);
    let secondGift = getCookie(`${window.cartgift_product2_id}`);
    let thirdGift = getCookie(`${window.cartgift_product3_id}`);
    let fourthGift = getCookie(`${window.cartgift_product4_id}`);

    //level 1 process
    let level1_min = +$('.level-1').attr('data-min');
    let level1_max = +$('.level-1').attr('data-max');
    let level1_percent = (current - level1_min) / (level1_max - level1_min) * 100;
    $('.progress-complete-1').css('width', level1_percent + '%');

    if (current < level1_max) {
        let level1_amount = (level1_max - current + 0.01).toFixed(2);
        amount.text('$' + level1_amount);
        product_gift.text(window.cartgift_name1);
        $('.cart-flex .cart-gift').find('.product-block').show();
    }
    //level 2 process
    let level2_min = +$('.level-2').attr('data-min');
    let level2_max = +$('.level-2').attr('data-max');
    let level2_percent = (current - level2_min) / (level2_max - level2_min) * 100;
    $('.progress-complete-2').css('width', level2_percent + '%');
    if (current > level1_max) {
        let level2_amount = (level2_max - current + 0.01).toFixed(2);
        amount.text('$' + level2_amount);
        product_gift.text(window.cartgift_name2);
        $('.cart-flex .cart-gift').find('.product-block').show();
        $('.cart-flex .cart-gift:nth-child(1)').find('.product-block').hide();
        if (level1 === false && firstGift === 'true' && !cartId.includes(`${window.cartgift_product1_id}`)) {
            jQuery.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: {
                    id: `${window.cartgift_product1_id}`,
                    quantity: 1,
                },
                dataType: 'json',
                success: function () {
                    $('.drawer__wrapper').click();
                }
            });
            level1 = true;
            console.log('product 1 added')
        }
    } else if (current < level2_max && cartId.includes(`${window.cartgift_product1_id}`)) {
        setTimeout(function () {
            console.log('delete 1')
            $(`.line-item[data-id="${window.cartgift_product1_id}"]`).find('.line-item__fakeremove-btn').click();
            level1 = false;
        }, 1400)
    }

    //level 3 process
    let level3_min = +$('.level-3').attr('data-min');
    let level3_max = +$('.level-3').attr('data-max');
    let level3_percent = (current - level3_min) / (level3_max - level3_min) * 100;
    $('.progress-complete-3').css('width', level3_percent + '%');
    if (current > level2_max) {
        let level3_amount = (level3_max - current + 0.01).toFixed(2);
        amount.text('$' + level3_amount);
        product_gift.text(window.cartgift_name3);
        $('.cart-flex .cart-gift').find('.product-block').show();
        $('.cart-flex .cart-gift:nth-child(1)').find('.product-block').hide();
        $('.cart-flex .cart-gift:nth-child(2)').find('.product-block').hide();
        if (level2 === false && secondGift === 'true' && !cartId.includes(`${window.cartgift_product2_id}`)) {
            jQuery.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: {
                    id: `${window.cartgift_product2_id}`,
                    quantity: 1,
                },
                dataType: 'json',
                success: function () {
                    $('.drawer__wrapper').click();
                }
            });
            level2 = true;
            console.log('product 2 added')
        }
    } else if (current < level3_max && cartId.includes(`${window.cartgift_product2_id}`)) {
        setTimeout(function () {
            console.log('delete 2')
            $(`.line-item[data-id="${window.cartgift_product2_id}"]`).find('.line-item__fakeremove-btn').click();
            level2 = false;
        }, 1200)
    }

    //level 4 process
    let level4_min = +$('.level-4').attr('data-min');
    let level4_max = +$('.level-4').attr('data-max');
    let level4_percent = (current - level4_min) / (level4_max - level4_min) * 100;
    $('.progress-complete-4').css('width', level4_percent + '%');
    if (current > level3_max) {
        let level4_amount = (level4_max - current + 0.01).toFixed(2);
        amount.text('$' + level4_amount);
        product_gift.text(window.cartgift_name4);
        $('.cart-flex .cart-gift').find('.product-block').show();
        $('.cart-flex .cart-gift:nth-child(1)').find('.product-block').hide();
        $('.cart-flex .cart-gift:nth-child(2)').find('.product-block').hide();
        $('.cart-flex .cart-gift:nth-child(3)').find('.product-block').hide();
        if (level3 === false && thirdGift === 'true' && !cartId.includes(`${window.cartgift_product3_id}`)) {
            jQuery.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: {
                    id: `${window.cartgift_product3_id}`,
                    quantity: 1,
                },
                dataType: 'json',
                success: function () {
                    $('.drawer__wrapper').click();
                }
            });
            level3 = true;
            console.log('product 3 added')
        }
    } else if (current < level4_max && cartId.includes(`${window.cartgift_product3_id}`)) {
        setTimeout(function () {
            console.log('delete 3')
            $(`.line-item[data-id="${window.cartgift_product3_id}"]`).find('.line-item__fakeremove-btn').click();
            level3 = false;
        }, 1100)
    }

    if (current > level4_max) {
        let level6_amount = (129.00 - current + 0.01).toFixed(2);
        amount.text('$' + level6_amount);
        product_gift.text(window.cartgift_name6);
        $('.cart-flex .cart-gift').find('.product-block').show();
        $('.cart-flex .cart-gift:nth-child(1)').find('.product-block').hide();
        $('.cart-flex .cart-gift:nth-child(2)').find('.product-block').hide();
        $('.cart-flex .cart-gift:nth-child(3)').find('.product-block').hide();
        $('.cart-flex .cart-gift:nth-child(4)').find('.product-block').hide();
        if (level4 === false && fourthGift === 'true' && !cartId.includes(`${window.cartgift_product4_id}`)) {
            jQuery.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: {
                    id: `${window.cartgift_product4_id}`,
                    quantity: 1,
                },
                dataType: 'json',
                success: function () {
                    $('.drawer__wrapper').click();
                }
            });
            level4 = true;
            console.log('product 4 added')
        }
    } else if (current < level4_max && cartId.includes(`${window.cartgift_product4_id}`)) {
        setTimeout(function () {
            console.log('delete 4')
            $(`.line-item[data-id="${window.cartgift_product4_id}"]`).find('.line-item__fakeremove-btn').click();
            level4 = false;
        }, 1000)
    }
    //30% OFF
    if(current > +cartgift_level6) {
        amount.text('$' + 0);
        $('.cart-flex .cart-gift:nth-child(6)').find('.product-block').hide();
    }
};

cartCallback = function(cart) {
    $('[data-drawer-target]').addClass('is-active').addClass('is-visible');
    $body.trigger('ajaxCart.afterCartLoad', cart);
};

loadCart = function () {
    ShopifyAPI.getCart(cartUpdateCallbackInitial);
};


document.addEventListener("DOMContentLoaded", function(event) {
    //gifts + progress bar
    setCookie(`${window.cartgift_product1_id}`, 'true');
    setCookie(`${window.cartgift_product2_id}`, 'true');
    setCookie(`${window.cartgift_product3_id}`, 'true');
    setCookie(`${window.cartgift_product4_id}`, 'true');


    function updateQuantity(line, qty) {
        isUpdating = true;

        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
    }
    adjustCartCallback = function (cart) {
        isUpdating = false;

        // Update quantity and price
        updateCountPrice(cart);

        // Reprint cart on short timeout so you don't see the content being removed
        setTimeout(function () {
            ShopifyAPI.getCart(buildCart);
        }, 150)
    };

    $(document).on('click', '.line-item__qty .btnqty', function () {
        var $el = $(this),
            line = $el.data('line'),
            $qtySelector = $el.siblings('.line-item__qty .quantity-input'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);


        // Add or subtract from the current quantity
        if ($el.hasClass('qtyplus')) {
            qty += 1;
        } else {
            qty -= 1;
            if (qty <= 0) qty = 1;
        }

        // If it has a data-line, update the cart.
        // Otherwise, just update the input's number
        if (line) {
            updateQuantity(line, qty);
        } else {
            $qtySelector.val(qty);
        }
    });
    $(document).on('click', '.line-item__header .line-item__remove-btn', function () {
        var $el = $(this),
            line = $el.data('line');
        let productId = $(this).closest('.line-item').attr('data-id');
        updateQuantity(line, 0);
        setCookie(productId, 'false');
        let removedGift = $(`.cart-gift .product-wrapper[data-id="${productId}"]`).closest('.cart-gift');
        removedGift.show();
        removedGift.find('.gift-added').hide();
        removedGift.find('.tt-description').css('opacity', '1');
    });
    $(document).on('click', '.line-item__header .line-item__fakeremove-btn', function () {
        var $el_fake = $(this),
            line_fake = $el_fake.data('line');
        updateQuantity(line_fake, 0);
        let productId = $(this).closest('.line-item').attr('data-id');
        let removedGift_fake = $(`.cart-gift .product-wrapper[data-id="${productId}"]`).closest('.cart-gift');
        removedGift_fake.show();
        removedGift_fake.find('.gift-added').hide();
        removedGift_fake.find('.tt-description').css('opacity', '1');
    });

    validateQty = function (qty) {
        if ((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
            // We have a valid number!
        } else {
            // Not a number. Default to 1.
            qty = 1;
        }
        return qty;
    };
    $('body').on('click', '.addtocart-item-js, .addtocart-js', function(e){
        e.preventDefault();
        let variant_id = $(this).closest('form').find('[name="id"]').val();
        let variant_qua = $(this).closest('form').find('[name="quantity"]').val();
        let variant_prop = $('.product-customizer-options');
        let properties = {};
        if(variant_prop.length > 0) {
            variant_prop.find('input, select').each(function () {
                let prop_label = $(this).closest('.product-customizer-option').find('label').text(),
                    prop_val = $(this).val();
                properties[prop_label] = prop_val;
            })
        }
        let data = {
            items: [
                {
                    quantity: variant_qua,
                    id: variant_id,
                    properties: properties
                },
            ],
        };
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            success: function (item) {
                //open cart
                $('.drawer').addClass('is-active is-visible');
                init();
                loadCart();
                formOverride();
            },
        });
    })
    $('.continue-shopping').click(function () {
        $('.drawer__close').click();
    })
    $('.proceed-to-checkout').click(function () {
        window.location.href = '/checkout';
    })
})